<template>
    <div>
        <div class="emailBox">
            <div class="emailTopBox">
                <div class="emailHeader">
                    <div class="emailTop">
                        <div class="headShot"><img :src="chatUserInfo.userDetail?.thumbnailUrl" alt="" srcset=""></div>
                        <div class="headName" v-if="chatUserInfo.emailType != 2">{{ chatUserInfo.userDetail.name }}
                        </div>
                        <!-- <div class="headNew">新</div> -->
                    </div>

                </div>
                <div class="emailTab">
                    <p class="row actionRow pointer" @click="addImageBtn">
                        <img src="@/assets/actionEmail.png" alt="">
                        电子邮件
                    </p>
                    <p class="row pointer" @click="addImageBtn">
                        <img src="@/assets/photosIcon.png" alt="">
                        图片/录音
                    </p>
                    <el-dropdown placement="top-start" trigger="click">
                        <span class="el-dropdown-link">
                            <p class="row pointer middle"> <img src="@/assets/emoji.png" alt=""> 表情</p>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width: 420px;">
                            <div class="emojiTabList">
                                <div class="tabItem" v-for="(item, index) in tabKeyList" :key="index"
                                    @click="tabClick(item)">{{ item }}</div>
                            </div>
                            <div class="emojiList">
                                <el-dropdown-item v-for="(item, index) in emojis" :key="index"
                                    @click.native="insertEmoji(item)">
                                    <img class="emoji" :src="item.FilePathUrl" alt=""></img>
                                </el-dropdown-item>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown placement="top-start" trigger="click">
                        <span class="el-dropdown-link">
                            <p class="row pointer middle"> <img src="@/assets/fyIcon.png" alt=""> {{
                                getCurrentLanguageText() }}</p>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width: 200px;">
                            <div class="languageList">
                                <el-dropdown-item @click.native="!isTranslating && selectLanguage('en')"
                                    :class="{ active: selectedLanguage === 'en', disabled: isTranslating }">
                                    <div class="languageOption">
                                        <span v-if="isTranslating && selectedLanguage === 'en'">翻译中...</span>
                                        <span v-else>英语</span>
                                        <span v-if="selectedLanguage === 'en' && !isTranslating"
                                            class="checkIcon">✓</span>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="!isTranslating && selectLanguage('es')"
                                    :class="{ active: selectedLanguage === 'es', disabled: isTranslating }">
                                    <div class="languageOption">
                                        <span v-if="isTranslating && selectedLanguage === 'es'">翻译中...</span>
                                        <span v-else>西班牙语</span>
                                        <span v-if="selectedLanguage === 'es' && !isTranslating"
                                            class="checkIcon">✓</span>
                                    </div>
                                </el-dropdown-item>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="emailContent">
                    <!-- 主题 -->
                    <div class="email-input-container">
                        <div class="highlight-overlay subject-highlight"
                            v-html="emailSubjectText ? $highlight(emailSubjectText) : emailSubjectText"></div>
                        <div ref="editorTheme" contenteditable="true" @input="onInputTheme" class="messageInput"
                            placeholder="请填写发送内容..."
                            style="white-space: pre-wrap; height: 40px; border-bottom: 1px solid #eee;"></div>
                    </div>
                    <div class="emailContentBox">
                        <div class="emailPhotoBox">
                            <div v-for="(item, index) in filePathList" :key="index" class="emailPhotoUrl"
                                @click="previewImage(item)">
                                <img :src="item.url" alt="" srcset="" v-if="item.type == 'image'">
                                <video :src="item.url" v-if="item.type == 'video'"></video>
                                <div class="audioBox" v-if="item.type == 'audio'">
                                    <img class="suspendIcon" src="@/assets/suspendIcon.png" alt="" srcset="">
                                    <img class="soundWaveIcon" src="@/assets/soundWaveIcon.png" alt="" srcset="">
                                </div>
                                <img src="@/assets/closeIcon.png" class="closeIcon" alt="" srcset=""
                                    @click="deleteFile(index)">
                            </div>
                        </div>
                        <!-- 内容 -->
                        <div class="email-input-container">
                            <div class="highlight-overlay content-highlight"
                                v-html="emailContentText ? $highlight(emailContentText) : emailContentText"></div>
                            <div ref="editor" contenteditable="true" @input="onInput" class="messageInput"
                                placeholder="请填写发送内容..." style="white-space: pre-wrap;" @keydown="keydownEvent"></div>
                        </div>
                    </div>
                </div>

                <!-- <p class="tips">探索我们共同旅程中的美好！</p>
                <div class="warnigMessage"> <img src="@/assets/warningsIcon.png" alt=""> 请仔细检查您的消息！</div> -->
                <div class="sendEmailBox">
                    <p class="refreshText" v-if="chatUserInfo.emailType != 2" @click="generatingEmailBtn"> <img
                            class="refreshIcon" src="@/assets/refreshIcon.png" alt="" srcset="">
                        点击更改建议</p>
                    <div class="protocolRow" v-if="chatUserInfo.emailType != 2">
                        <img v-if="!isCheck" @click="setMuted" src="@/assets/unSelectIcon.png" alt="">
                        <img v-else @click="setMuted" src="@/assets/checkSelectIcon.png" alt="">
                        我已经审阅了信息，并完全接受最终版本的责任。
                    </div>
                    <div class="sendEmailBtn" v-if="chatUserInfo.emailType == 2" @click="saveSubmit"> <img
                            src="@/assets/sendEmailIcon.png" alt=""> 提交 </div>

                    <div v-else
                        style="margin: auto;margin-top: 24px;display: flex;justify-content: center;align-items: center;">
                        <!-- <div style="margin-right: 5px;">{{countPureTextNum}}/700</div> -->
                        <div :class="['sendEmailBtn', { 'sendEmailBtn--loading': datingEmailLoading }]"
                            style="margin: 0;" @click="!datingEmailLoading && sendEmailFn()">
                            <i v-if="datingEmailLoading" class="el-icon-loading" style="margin-right: 8px;"></i>
                            <img v-else src="@/assets/sendEmailIcon.png" alt="">
                            {{ datingEmailLoading ? '邮件加载中...' : '发送邮件' }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-bar">
                <div class="arrow arrowLeft" @click="scrollLeft"> <img src="@/assets/arrowLeft.png" alt="" srcset="">
                </div>
                <div ref="tabContainer" class="tab-container">
                    <div v-for="(tab, index) in coverList" :key="index"
                        :class="[index === coverIndex ? 'tab overlay' : 'tab']" class="tab" style="position: relative;"
                        @click="clickCover(tab, index)">
                        <div class="img">
                            <img :src="tab.coverUrl" alt="" srcset="">
                            <div class="overlay" v-if="index === coverIndex"></div>
                        </div>
                        <img class="selectIcon" v-if="index === coverIndex" src="@/assets/selectIcon.png" alt=""
                            srcset="">
                        <!-- <div class="text">{{ tab }}</div> -->
                    </div>
                </div>
                <div class="arrow arrowRight" @click="scrollRight"><img src="@/assets/arrowRight.png" alt="" srcset="">
                </div>
            </div>
            <el-upload ref="uploader" class="upload-demo" action="#" :auto-upload="false" :on-remove="handleRemove"
                :before-remove="beforeRemove" :limit="1" :on-change="handleChange"
                accept=".jpg,.jpeg,.png,.xbm,.tif,.pjp,.apng,.svgz,.icon,.tiff,.gif,svg,.jfif,.webp,.bmp,.pjpeg,.avif,.ogm,.wmv,.mpg,.webm,.ogv,.mov,.asx,.mpeg,.mp4,.m4v,.avi,.mp3,.m4a">
                <!-- 隐藏这个按钮 -->
                <el-button ref="uploadBtn" style="display: none">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
        </div>
        <el-dialog title="" :modal="false" class="emailDialog" :visible.sync="viewShow" width="600px"
            :before-close="handleClose">
            <img class="viewImage" v-if="fileInfo.type == 'image'" :src="fileInfo.url" alt="" srcset="">
            <video class="viewImage" controls v-if="fileInfo.type == 'video'" :src="fileInfo.url" alt=""
                srcset=""></video>
            <audio :src="fileInfo.url" controls v-if="fileInfo.type == 'audio'"></audio>
        </el-dialog>
    </div>
</template>

<script>
import { getEmailCoverList, getSmilesList, uploadFile, } from '@/api/dialogue'
import { emailSmilesList, addIntroductoryEmail, introductoryEmail } from '@/api/batchSending'
import { translate } from '@/api/youdaoSign'

export default {
    name: 'SendEmail',
    data() {
        return {
            coverList: [],
            coverIndex: 0,
            tabs: ['Tab 1', 'Tab 2Tab 2Tab 2', 'Tab 3', 'Tab 4', 'Tab 5', 'Tab 6'], // Tab的数据
            scrollStep: 100, // 每次滚动的距离，100px
            scrollPosition: 0, // 当前滚动的位置
            tabOffsetWidth: 0, // 元素的可见宽度，包括元素的内容宽度、内边距和边框宽度
            tabScrollWidth: 0,// 元素的内容宽度，包括被隐藏的部分
            tabClientWidth: 0, // 元素的可见宽度，不包括滚动条和边框的宽度
            message: '',
            isCheck: false,
            tabKeyList: [],
            emojis: [],
            content: '',
            filePathList: [], // 用于存储上传的图片或视频路径
            emailCoverUrl: '', // 用于存储选中的封面图片URL
            emailCover: '', // 用于存储选中的封面图片名称
            viewShow: false,
            fileInfo: {},
            countPureTextNum: 0,
            selectedLanguage: 'en', // 当前选中的语言版本
            originalContent: '', // 原始内容
            originalSubject: '', // 原始主题
            emailEsContent: '', // 西班牙语内容
            emailEsSubject: '', // 西班牙语主题
            emailEnContent: '', // 英语内容
            emailEnSubject: '', // 英语主题
            isTranslating: false, // 是否正在翻译
            emojisList: {}, // 表情分类列表
            emojisKey: '', // 当前选中的表情分类
            emailSubjectText: '', // 邮件主题纯文本，用于敏感词高亮
            emailContentText: '', // 邮件内容纯文本，用于敏感词高亮
            lastRange: null, // 保存最后的光标位置
        }
    },
    props: {
        chatUserInfo: {
            type: Object,
            default: () => { }
        },
        openType: {
            type: Number,
            default: 1 // 1: 新建邮件 2: 编辑邮件
        },
        emailType: {
            type: Number,
            default: 1 // 1: 普通邮件 2: 邀请邮件
        },
        emailFileList: {
            type: Array,
            default: () => []
        },
        datingEmailLoading: {
            type: Boolean,
            default: false
        },
        // isShow: {
        //     type: Boolean,
        //     default: false
        // }

    },
    watch: {
        // isShow: {
        //     handler(newVal) {
        //         console.log(newVal)
        //         if (newVal) {
        //             this.countPureText(this.message);
        //         }
        //     },
        //     immediate: true  // 立即以当前值触发回调
        // },
        chatUserInfo: {
            deep: true,
            immediate: true,
            handler(newVal) {
                console.log(newVal, 'chatUserInfo2333')
                // if(newVal.emailContent && newVal.emailContent.length > 0){
                //     this.countPureText(newVal.emailContent)
                // }
                if (this.emailType == 1 && newVal) {
                    this.$nextTick(() => {
                        this.invitationEmail();
                    });
                }
            },
        },
        emailFileList: {
            deep: true,
            handler(newVal) {
                console.log(newVal, 'emailFileList')
                console.log(newVal && newVal.length > 0, 'newVal && newVal.length > 0')
                // 这里可以处理 emailFileList 的变化
                if (newVal && newVal.length > 0) {
                    this.filePathList.push(...newVal);
                }
            }
        },
    },
    mounted() {
        this.getEmailCoverList()
        this.getSmilesList()
        console.log(this.chatUserInfo, 'chatUserInfo111')
        this.$nextTick(() => {
            if (this.$refs.editor) {
                this.$refs.editor.focus();
                // 添加事件监听，保存最后的光标位置
                this.$refs.editor.addEventListener('mouseup', this.saveSelection);
                this.$refs.editor.addEventListener('keyup', this.saveSelection);
            }
            this.invitationEmail();
        });
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听
        if (this.$refs.editor) {
            this.$refs.editor.removeEventListener('mouseup', this.saveSelection);
            this.$refs.editor.removeEventListener('keyup', this.saveSelection);
        }
    },
    methods: {

        // 获取当前语言显示文本
        getCurrentLanguageText() {
            switch (this.selectedLanguage) {
                case 'es':
                    return this.isTranslating ? '翻译中...' : '西班牙语';
                case 'en':
                default:
                    return this.isTranslating ? '翻译中...' : '英语';
            }
        },

        // 选择语言版本
        selectLanguage(language) {
            if (this.isTranslating) return;

            this.selectedLanguage = language;

            switch (language) {
                case 'en':
                    // 显示英语内容（默认内容）
                    this.$refs.editor.innerHTML = this.emailEnContent || '';
                    this.$refs.editorTheme.innerHTML = this.emailEnSubject || '';
                    break;
                case 'es':
                    if (!this.emailEsContent || !this.emailEsSubject) {
                        return this.translateContent(language);
                    }
                    this.$refs.editor.innerHTML = this.emailEsContent;
                    this.$refs.editorTheme.innerHTML = this.emailEsSubject;
                    break;
            }
        },

        // 翻译内容
        async translateContent(targetLang) {
            if (!this.$refs.editor.innerHTML.trim() && !this.$refs.editorTheme.innerHTML.trim()) {
                this.$message.warning('请先输入邮件内容');
                this.selectedLanguage = 'en';
                return;
            }

            // 保存英语内容作为原始内容
            if (!this.emailEnContent) {
                this.emailEnContent = this.$refs.editor.innerHTML;
            }
            if (!this.emailEnSubject) {
                this.emailEnSubject = this.$refs.editorTheme.innerHTML;
            }

            this.isTranslating = true;

            try {
                // 翻译邮件内容
                if (this.$refs.editor.innerHTML.trim()) {
                    const contentText = this.$refs.editor.innerText;
                    const translatedContent = await translate(contentText, 'auto', targetLang);
                    this.$refs.editor.innerHTML = translatedContent;
                    // 保存对应语言的内容
                    switch (targetLang) {
                        case 'es':
                            this.emailEsContent = translatedContent;
                            break;
                    }
                }

                // 翻译邮件主题
                if (this.$refs.editorTheme.innerHTML.trim()) {
                    const subjectText = this.$refs.editorTheme.innerText;
                    const translatedSubject = await translate(subjectText, 'auto', targetLang);
                    this.$refs.editorTheme.innerHTML = translatedSubject;
                    // 保存对应语言的主题
                    switch (targetLang) {
                        case 'es':
                            this.emailEsSubject = translatedSubject;
                            break;
                    }
                }

            } catch (err) {
                this.$message.error('翻译失败: ' + err.message);
                // 翻译失败时回到英语内容
                this.selectedLanguage = 'en';
                if (this.emailEnContent) {
                    this.$refs.editor.innerHTML = this.emailEnContent;
                }
                if (this.emailEnSubject) {
                    this.$refs.editorTheme.innerHTML = this.emailEnSubject;
                }
            } finally {
                this.isTranslating = false;
            }
        },
        // 邀请邮件
        invitationEmail() {
            console.log(this.chatUserInfo, 'chatUserInfo111')
            this.content = this.chatUserInfo.emailContent
            const editor = this.$refs.editor;
            editor.innerHTML = this.content || '';
            const editorTheme = this.$refs.editorTheme;
            editorTheme.innerHTML = this.chatUserInfo.emailSubject || '';

            // 初始化用于敏感词高亮的纯文本内容
            this.emailContentText = editor.innerText || '';
            this.emailSubjectText = editorTheme.innerText || '';

            // 赋值给对应语言的内容
            this.emailEnContent = this.chatUserInfo.emailContent || '';
            this.emailEnSubject = this.chatUserInfo.emailSubject || '';
            this.emailEsContent = this.chatUserInfo.emailEsContent || '';
            this.emailEsSubject = this.chatUserInfo.emailEsSubject || '';
            // this.filePathList = this.chatUserInfo.emailPhotoUrl || [];

            console.log(this.chatUserInfo.emailPhotoUrl, 'emailPhotoUrl')
            console.log(this.chatUserInfo.emailVideoUrl, 'emailVideoUrl')
            console.log(this.chatUserInfo.emailAudioUrl, 'emailAudioUrl')
            let emailPhotoUrl = this.chatUserInfo.emailPhotoUrl;
            let emailPhoto = this.chatUserInfo.emailPhoto;
            let emailVideoUrl = this.chatUserInfo.emailVideoUrl;
            let emailVideo = this.chatUserInfo.emailVideo;
            let emailAudioUrl = this.chatUserInfo.emailAudioUrl;
            let emailAudio = this.chatUserInfo.emailAudio;
            if (this.emailType != 1) {
                if (emailPhotoUrl && emailPhotoUrl.length > 0) {
                    emailPhotoUrl.map((item, index) => {
                        this.filePathList.push({
                            url: item,
                            ossId: emailPhoto[index] || '', // 如果有ossId可以在这里设置
                            type: 'image', // 假设所有上传的都是图片
                        });
                    })
                }
                if (emailVideoUrl && emailVideoUrl.length > 0) {
                    emailVideoUrl.map((item, index) => {
                        this.filePathList.push({
                            url: item,
                            ossId: emailVideo[index] || '', // 如果有ossId可以在这里设置
                            type: 'video', // 假设所有上传的都是图片
                        });
                    })
                }

                if (emailAudioUrl && emailAudioUrl.length > 0) {
                    emailAudioUrl.map((item, index) => {
                        this.filePathList.push({
                            url: item,
                            ossId: emailAudio[index] || '', // 如果有ossId可以在这里设置
                            type: 'audio', // 假设所有上传的都是图片
                        });
                    })
                }


            }
            // this.filePathList = emailPhotoUrl.map((url, index) => ({
            //     url: url,
            //     ossId: emailPhoto[index], // 如果有ossId可以在这里设置
            //     type: 'image', // 假设所有上传的都是图片
            // }));
        },
        getEmailCoverList() {
            getEmailCoverList({
                platformType: this.chatUserInfo.platformType || this.chatUserInfo.userDetail.platformType,
            }).then(res => {
                this.$nextTick(() => {
                    this.tabOffsetWidth = this.$refs.tabContainer.offsetWidth;
                    this.tabScrollWidth = this.$refs.tabContainer.scrollWidth;
                    this.tabClientWidth = this.$refs.tabContainer.clientWidth;
                    let emailHeader = document.querySelector('.emailHeader')
                    emailHeader.style.backgroundImage = `url(${this.coverList[this.coverIndex].coverUrl})`
                    this.emailCoverUrl = this.coverList[this.coverIndex].coverUrl;
                    this.emailCover = this.coverList[this.coverIndex].cover
                })
                this.coverList = res
            })
        },
        // 获取表情列表
        getSmilesList() {
            emailSmilesList().then(res => {
                this.emojis = res.data;
            })
        },

        // 表情分类切换
        tabClick(key) {
            console.log('key,', key)
            this.emojisKey = key;
            this.emojis = this.emojisList[key]
        },
        onInputTheme() {
            const editorTheme = this.$refs.editorTheme;
            // 更新纯文本内容用于敏感词高亮，保持完整的HTML结构
            this.emailSubjectText = editorTheme.innerHTML;

            // 更新对应语言的主题
            switch (this.selectedLanguage) {
                case 'en':
                    this.emailEnSubject = editorTheme.innerHTML;
                    break;
                case 'es':
                    this.emailEsSubject = editorTheme.innerHTML;
                    break;
            }
        },
        previewImage(item) {
            console.log(item)
            this.fileInfo = item
            this.viewShow = true;
        },
        deleteFile(index) {
            this.filePathList.splice(index, 1);
            console.log(this.filePathList, '删除后')
        },
        addImageBtn() {
            this.$emit('itemClick', 5);
            return;
            this.$refs.uploader.$el.querySelector('input[type="file"]').click();

        },
        handleChange(file, fileList) {
            let formData = new FormData()
            formData.append('file', file.raw)
            if (file.size > 50 * 1024 * 1024) {
                this.$message.error('文件大小不能超过50M');
            }
            const isImage = file.raw.type.startsWith('image/');
            const isVideo = file.raw.type.startsWith('video/');
            const isAudio = file.raw.type.startsWith('audio/');
            if (isImage) {
                console.log('上传的是图片');
                // 发送图片消息
                this.uploadFile(formData, 'image');
            } else if (isVideo) {
                console.log('上传的是视频');
                // 发送视频消息
                this.uploadFile(formData, 'video');
            } else if (isAudio) {
                this.uploadFile(formData, 'audio');
            } else {
                this.$message.error('请上传图片或视频');
            }
        },
        uploadFile(formData, type) {
            uploadFile(formData).then(res => {
                if (res.code == 200) {
                    this.filePathList.push({
                        url: res.data.url,
                        ossId: res.data.ossId,
                        type: type,
                    });
                    console.log(res, '上传成功')
                }
                this.$refs.uploader.clearFiles();

            })
        },
        beforeRemove(file, fileList) {

        },
        handleRemove(file, fileList) {

        },
        // 保存光标位置
        saveSelection() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                this.lastRange = selection.getRangeAt(0);
            }
        },

        // 恢复光标位置
        restoreSelection() {
            const editor = this.$refs.editor;
            if (this.lastRange && editor) {
                editor.focus();
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(this.lastRange);
            }
        },
        // 插入表情
        insertEmoji(emoji) {
            const editor = this.$refs.editor;
            if (!editor) return;

            // 恢复最后保存的光标位置
            this.restoreSelection();

            // 创建图片元素
            const img = document.createElement('img');
            img.src = emoji.FilePathUrl;
            img.style.cssText = 'width: 40px !important; height: 40px !important; display: inline-block !important; margin: 0 6px !important; vertical-align: middle !important; object-fit: contain !important;';

            // 获取当前选区
            const selection = window.getSelection();
            if (!selection.rangeCount) return;

            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(img);

            // 将光标移到图片之后
            range.setStartAfter(img);
            range.collapse(true);

            // 更新选区
            selection.removeAllRanges();
            selection.addRange(range);

            // 保存新的光标位置
            this.lastRange = range;

            // 更新数据模型
            this.message = editor.innerHTML;
            this.countPureTextNum = this.countPureText(this.message);

            // 立即触发 onInput 事件以更新高亮
            this.onInput();

            // 保持编辑器焦点
            editor.focus();
        },
        setMuted() {
            this.isCheck = !this.isCheck
        },
        onInput() {
            const editor = this.$refs.editor;
            this.message = editor.innerHTML;
            this.countPureTextNum = this.countPureText(this.message);

            // 更新纯文本内容用于敏感词高亮，保持完整的HTML结构
            this.emailContentText = editor.innerHTML;

            // 更新对应语言的内容
            switch (this.selectedLanguage) {
                case 'en':
                    this.emailEnContent = editor.innerHTML;
                    break;
                case 'es':
                    this.emailEsContent = editor.innerHTML;
                    break;
            }
        },
        countPureText(text) {
            // 保留：中文（\u4e00-\u9fa5）、英文（a-zA-Z）、数字（0-9）、空格
            const pureText = text.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s]/g, '');
            this.countPureTextNum = pureText.length;
            return pureText.length;
        },
        keydownEvent(event) {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault(); // 阻止默认的回车换行行为
                this.itemClick(0);
            }
        },
        generatingEmailBtn() {
            console.log('generatingEmail')

            this.$emit('generatingEmail');
        },
        sendEmailFn() {
            if (!this.isCheck) {
                this.$message.error('请先阅读协议并勾选');
                return
            }
            if (!this.$refs.editorTheme.innerHTML) {
                this.$message.error('请填写邮件主题');
                return
            }
            if (!this.$refs.editor.innerHTML) {
                this.$message.error('请填写邮件内容');
                return
            }
            const typeMap = {
                image: 'photo',
                video: 'video',
                audio: 'audio'
            };

            // 构建附件数据
            let attachments = this.filePathList.map(item => {
                return `${[typeMap[item.type]]}:${item.ossId}`
            });

            // 构建本地消息数据
            let localMessageData = {
                emailSubject: this.$refs.editorTheme.innerHTML,
                emailContent: this.$refs.editor.innerHTML,
                cover: this.emailCover,
                attachments: attachments,
                // 添加图片、视频、音频的URL数组，用于本地显示
                emailPhotoUrl: this.filePathList.filter(item => item.type === 'image').map(item => item.url),
                emailPhoto: this.filePathList.filter(item => item.type === 'image').map(item => item.ossId),
                emailVideoUrl: this.filePathList.filter(item => item.type === 'video').map(item => item.url),
                emailVideo: this.filePathList.filter(item => item.type === 'video').map(item => item.ossId),
                emailAudioUrl: this.filePathList.filter(item => item.type === 'audio').map(item => item.url),
                emailAudio: this.filePathList.filter(item => item.type === 'audio').map(item => item.ossId)
            };

            // 发送邮件
            this.$emit('sendEmailFn', JSON.stringify(localMessageData));

            // 清空编辑器和文件列表
            this.$refs.editorTheme.innerHTML = '';
            this.$refs.editor.innerHTML = '';
            this.filePathList = [];
        },
        saveSubmit() {
            // this.$refs.editorTheme.innerText = this.$refs.editorTheme.innerText.replace(/<[^>]+>/g, "");
            // console.log(this.$refs.editor.innerHTML, 'this.$refs.editorTheme.innerText')
            // return
            // if(this.countPureTextNum < 700){
            //     this.$message.error('邮件内容不能少于700个字符');
            //     return
            // }
            console.log('this.content', this.content)
            console.log('this.content', this.content)
            if (this.openType == 1) {
                this.addEmail()
            } else if (this.openType == 2) {
                this.editEmail()
            }
        },
        addEmail() {
            let emailPhotoUrl = []
            let emailPhoto = []
            let emailVideoUrl = []
            let emailVideo = []
            let emailAudioUrl = []
            let emailAudio = []
            console.log(this.filePathList, 'this.filePathList')
            this.filePathList.forEach(item => {
                if (item.type == 'image') {
                    emailPhotoUrl.push(item.url)
                    emailPhoto.push(item.ossId)
                } else if (item.type == 'video') {
                    emailVideoUrl.push(item.url)
                    emailVideo.push(item.ossId)
                } else if (item.type == 'audio') {
                    emailAudioUrl.push(item.url)
                    emailAudio.push(item.ossId)
                } else {

                }
            })
            console.log(this.chatUserInfo, 'this.chatUserInfo')
            addIntroductoryEmail({
                platformType: this.chatUserInfo.platformType || this.chatUserInfo.userDetail.platformType,
                // recId: this.chatUserInfo.recId,
                emailSubject: this.emailEnSubject, // 英语内容
                emailContent: this.emailEnContent, // 英语内容
                emailEsSubject: this.emailEsSubject,
                emailEsContent: this.emailEsContent,
                emailPhotoUrl: emailPhotoUrl.join(','),
                emailPhoto: emailPhoto.join(','),
                emailCoverUrl: this.emailCoverUrl,
                emailCover: this.emailCover,
                emailVideoUrl: emailVideoUrl.join(','),
                emailVideo: emailVideo.join(','),
                emailAudioUrl: emailAudioUrl.join(','),
                emailAudio: emailAudio.join(','),
                platformUserId: this.chatUserInfo.platformUserId || this.chatUserInfo.userDetail.platformUserId,

            }).then(res => {
                if (res.code == 200) {
                    this.$message.success('提交成功')
                    this.$emit('closeSendEmail')
                }
            })
        },
        editEmail() {
            let emailPhotoUrl = []
            let emailPhoto = []
            let emailVideoUrl = []
            let emailVideo = []
            let emailAudioUrl = []
            let emailAudio = []
            console.log(this.filePathList, 'this.filePathList')
            this.filePathList.forEach(item => {
                if (item.type == 'image') {
                    emailPhotoUrl.push(item.url)
                    emailPhoto.push(item.ossId)
                } else if (item.type == 'video') {
                    emailVideoUrl.push(item.url)
                    emailVideo.push(item.ossId)
                } else if (item.type == 'audio') {
                    emailAudioUrl.push(item.url)
                    emailAudio.push(item.ossId)
                } else {

                }
            })
            console.log(this.chatUserInfo, 'this.chatUserInfo')
            introductoryEmail({
                platformType: this.chatUserInfo.platformType || this.chatUserInfo.userDetail.platformType,
                recId: this.chatUserInfo.recId,
                emailSubject: this.emailEnSubject, // 英语内容
                emailContent: this.emailEnContent, // 英语内容
                emailEsSubject: this.emailEsSubject,
                emailEsContent: this.emailEsContent,
                emailPhotoUrl: emailPhotoUrl.join(','),
                emailPhoto: emailPhoto.join(','),
                emailCoverUrl: this.emailCoverUrl,
                emailCover: this.emailCover,
                emailVideoUrl: emailVideoUrl.join(','),
                emailVideo: emailVideo.join(','),
                emailAudioUrl: emailAudioUrl.join(','),
                emailAudio: emailAudio.join(','),
                platformUserId: this.chatUserInfo.platformUserId || this.chatUserInfo.userDetail.platformUserId,

            }).then(res => {
                if (res.code == 200) {
                    this.$message.success('提交成功')
                    this.$emit('closeSendEmail')
                }
            })
        },
        clickCover(item, index) {
            console.log(item, index, '点击封面')
            this.coverIndex = index;
            let emailHeader = document.querySelector('.emailHeader');
            emailHeader.style.backgroundImage = `url(${item.coverUrl})`
            this.emailCoverUrl = item.coverUrl;
            this.emailCover = item.cover
        },
        handleClose() {
            this.viewShow = false;
        },
        scrollLeft() {
            if (this.scrollPosition > 0) {
                this.scrollPosition -= this.scrollStep;
                this.$refs.tabContainer.scrollTo({
                    left: this.scrollPosition,
                    behavior: 'smooth',
                });
            }
        },
        scrollRight() {
            if (this.scrollPosition < this.$refs.tabContainer.scrollWidth - this.tabOffsetWidth) {
                this.scrollPosition += this.scrollStep;
                this.$refs.tabContainer.scrollTo({
                    left: this.scrollPosition,
                    behavior: 'smooth',
                });
            }
        },
    }
}

</script>


<style lang="scss" scoped>
.emailBox {
    .emailTopBox {
        padding: 24px;

    }

    .email-input-container {
        position: relative;

        .highlight-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: transparent;
            pointer-events: none;
            white-space: pre-wrap;
            word-break: break-all;
            overflow-wrap: break-word;
            overflow: hidden;
            z-index: 2;
            padding: 12px;
            margin: inherit;
            border: inherit;
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
            color: #333;
            /* 确保文本可见 */
        }

        .subject-highlight {
            height: 40px;
            border-bottom: 1px solid #eee;
        }

        .content-highlight {
            min-height: 100px;
        }

        .messageInput {
            position: relative;
            z-index: 1;
            background-color: transparent;
            color: transparent;
            caret-color: #333;
            /* 保持光标可见 */
        }

        .messageInput::placeholder {
            color: #999;
            /* placeholder颜色 */
        }
    }

    .emailHeader {
        height: 218px;
        width: 100%;
        border-radius: 8px;
        background-image: url('@/assets/emailBg.png');
        background-size: 100% 100%;

    }

    .emailTop {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .headShot {
        width: 78px;
        height: 78px;
        background: red;
        border-radius: 50%;
        margin-bottom: 10px;
        margin-top: 40px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    .headName {
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        // line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 10px;
    }

    .headNew {
        width: 38px;
        height: 20px;
        background: #FF2424;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #FF2424;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
        font-style: normal;
        text-transform: none;
        text-align: center;
    }

    .emailTab {
        display: flex;
        align-items: center;

        .row {
            display: flex;
            padding: 12px 40px;

            img {
                width: 22px;
                margin-right: 8px;
            }
        }
    }

    .actionRow {
        background: #EEEEEE;
        border-radius: 8px 8px 8px 8px;
    }

    .emailContent {
        height: 200px;

        .messageInput {
            // background-color: #F7F9FA;
            border-radius: 20px;
            box-sizing: border-box;
            height: 100%;
            // background: #F7F9FA;
            border: none;
            // border-radius: 20px 4px 20px 20px;
            // padding-left: 50px;
            // padding-top: 14px;
            padding: 12px;
            resize: none;
        }
    }

    :deep(.messageInput:focus) {
        outline: none;
    }

    .tips {
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 18px 0;
    }

    .warnigMessage {
        display: flex;
        align-items: center;
        background: #F7F9FA;
        border-radius: 4px 4px 4px 4px;
        padding: 12px;

        img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
        }
    }

    .protocolRow {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        img {
            width: 18px;
            height: 18px;
            margin-right: 6px;
            cursor: pointer;
        }
    }

    .sendEmailBtn {
        // padding: 12px 40px;
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: #FF2424;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        width: 182px;
        height: 44px;
        align-items: center;
        justify-content: center;
        margin: auto;
        margin-top: 24px;
        cursor: pointer;
        transition: all 0.3s ease;

        img {
            width: 22px;
            height: 18px;
            margin-right: 8px;
        }

        &--loading {
            background: #ccc;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    .tab-bar {
        display: flex;
        align-items: center;
        position: relative;
    }

    .arrow {
        width: 30px;
        height: 30px;
        cursor: pointer;
        z-index: 999;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .arrowLeft {
        position: absolute;
        left: 12px;
        bottom: 26px;

    }

    .arrowRight {
        position: absolute;
        right: 12px;
        bottom: 26px;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(128, 128, 128, 0.5);
        /* 半透明黑色蒙层 */
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        z-index: 1;
        font-size: 20px;
        font-weight: bold;
    }

    .tab-container {
        display: flex;
        width: 100%;
        overflow-x: hidden;
    }

    .tab {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // min-width: 25%;
        width: 100%;
        text-align: center;
        background-color: #3a7fa9;
    }

    .text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .img {
        flex-shrink: 0;
        width: 180px;
        height: 80px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            // border-radius: 8px;
        }
    }

    .selectIcon {
        position: absolute;
        width: 26px;
        height: 18px;
        z-index: 9999;
    }

    .refreshText {
        font-weight: 400;
        font-size: 16px;
        color: #2499FF;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        align-items: center;
        cursor: pointer;

        .refreshIcon {
            width: 16px;
            height: 16px;
            margin-right: 6px;
        }
    }



}

.emojiList {
    // width: 300px;
    display: flex;
    height: 120px;
    flex-wrap: wrap;
    overflow: auto;
    align-content: flex-start;

    .emoji {
        width: 40px;
        height: 40px;
        // padding: 6px 6px;

    }

}

.emojiTabList {
    width: 100%;
    display: flex;
    padding: 0 20px;
    margin-bottom: 10px;

    .tabItem {
        // width: 40px;
        padding: 0 10px;
        text-align: center;
        cursor: pointer;
    }
}

:deep(.el-dropdown) {
    display: block !important;
}

.emailPhotoBox {
    display: flex;

    .emailPhotoUrl {
        width: 100px;
        height: 100px;
        margin-right: 20px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        video {
            width: 100%;
            height: 100%;
        }
    }
}

.emailContentBox {
    max-height: 160px;
    overflow-y: auto
}

.closeIcon {
    width: 12px !important;
    height: 12px !important;
    cursor: pointer;
    position: absolute;
    right: 4px;
    top: 4px;
}

:deep(.el-upload-list) {
    display: none;
}

.audioBox {
    width: 100px;
    height: 100px;
    background: #F7F9FA;
    overflow: hidden;
    border-radius: 6px;

    .suspendIcon {
        width: 30px !important;
        height: 30px !important;
        margin: auto;
        margin-top: 30px;
    }

    .soundWaveIcon {
        width: 56px !important;
        height: 20px !important;
        margin: auto;
        margin-top: 10px;
    }
}

.viewImage {
    width: 500px;
    // margin: auto;
    max-height: 500px;

}

::v-deep .el-dialog__body {
    padding: 20px !important;
    height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.languageList {
    padding: 8px 0;
}

.languageOption {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 16px;
}

.checkIcon {
    color: #FF2424;
    font-weight: bold;
}

:deep(.el-dropdown-menu__item.active) {
    color: #FF2424;
    background-color: #fff5f5;
}

:deep(.el-dropdown-menu__item.disabled) {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
}
</style>